import { NgxChartsModule } from '@swimlane/ngx-charts';
import { InquiryModule } from './inquiries/inquiry.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { LayoutModule } from './layout/layout.module';
import { PagesModule } from './pages/pages.module';
import { TravelersModule } from './travelers/travelers.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { SettingsModule } from './settings/settings.module';
import { FiltersModule } from './filters/filters.module';
import { SharedModule } from './shared/shared.module';
import { ExperiencesModule } from './experiences/experiences.module';
import { PackagesModule } from './packages/packages.module';
import { BookingsModule } from './bookings/bookings.module';
import { LocalsModule } from './locals/locals.module';
import { AccommodationModule } from './accommodation/accommodation.module';
import { DestinationsModule } from './destinations/destinations.module';
ToastDefaults.toast.showProgressBar = false;
ToastDefaults.toast.position = 'rightTop';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    LayoutModule,
    PagesModule,
    TravelersModule,
    AuthenticationModule,
    SettingsModule,
    FiltersModule,
    SnotifyModule.forRoot(),
    HttpClientModule,
    ExperiencesModule,
    PackagesModule,
    BookingsModule,
    LocalsModule,
    AccommodationModule,
    InquiryModule,
    NgxChartsModule,
    SharedModule,
    DestinationsModule
  ],
  providers: [
    { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
